export const name_salutations_values = [
  { label: "Mr.", value: "Mr." },
  { label: "Mrs.", value: "Mrs." },
  { label: "Miss", value: "Miss" },
  { label: "Dr.", value: "Dr." },
  { label: "Ms.", value: "Ms." },
  { label: "Prof.", value: "Prof." },
];
